/*
 * <aov-cross-sell> — bloque de cross-sell "Se compran juntos".
 * Lazy-load con fallback en 3 niveles: COMPLEMENTARY (Search & Discovery) →
 * RELATED (automático) → colección fallback "más vendidos" (renderizada en un
 * <template data-aov-fallback> en el render inicial del PDP). Si no hay nada, se
 * auto-remueve. Motor reusable de la Suite AOV (ver spec 2026-06-24).
 */
class AovCrossSell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadFrom(this.dataset.urlComplementary, 'complementary');
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }

  loadFrom(url, stage) {
    if (!url) {
      this.useFallback();
      return;
    }
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const inner = html.querySelector('aov-cross-sell');
        const hasProducts = html.querySelector('.grid__item');

        if (inner && hasProducts && inner.innerHTML.trim().length) {
          this.innerHTML = inner.innerHTML;
          this.classList.add('product-recommendations--loaded');
        } else if (stage === 'complementary' && this.dataset.urlRelated) {
          this.loadFrom(this.dataset.urlRelated, 'related');
        } else {
          this.useFallback();
        }
      })
      .catch((e) => {
        console.error(e);
        if (stage === 'complementary' && this.dataset.urlRelated) {
          this.loadFrom(this.dataset.urlRelated, 'related');
        } else {
          this.useFallback();
        }
      });
  }

  useFallback() {
    const tpl = this.querySelector('template[data-aov-fallback]');
    if (tpl && tpl.innerHTML.trim().length) {
      this.innerHTML = tpl.innerHTML;
      this.classList.add('product-recommendations--loaded');
    } else {
      this.remove();
    }
  }
}

customElements.define('aov-cross-sell', AovCrossSell);
